import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CategorieDocumente, CategorieDocumenteEditPayload } from './categorii-documente.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CategoriiDocumenteService {
    private token!: string;
    private httpOptions: any;
    private basePath = environment.interop.basePath;

    private getCategoriiDocumenteUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.categoriiDocumente.getCategorii;
    private storeCategorieDocumentURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.categoriiDocumente.storeCategorie;

    private deleteCategorieDocumenteUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.categoriiDocumente.deleteCategorie;

    private getCategoriiDocumenteActiveUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.categoriiDocumente
            .getCategoriiActive;

    private getCategoriiDocumentePublicUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.categoriiDocumente
            .getCategoriiPublic;

    private updateCategorieDocumenteUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.categoriiDocumente.updateCategorii;

    private updateOrderUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.categoriiDocumente.updateOrder;


    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.categoriiDocumente
            .changeStatusCategoriiActive;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.categoriiDocumente
            .changeStatusCategoriiPublic;

    constructor(private http: HttpClient) { }

    addCategorie(data: CategorieDocumente) {
        return this.http.post(this.storeCategorieDocumentURL, data, this.httpOptions);
    }

    getCategoriiDocumente() {
        return this.http.get(this.getCategoriiDocumenteUrl, this.httpOptions);
    }

    getCategoriiDocumenteActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCategoriiDocumenteActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get categorii documente active:', error);
                    return throwError(error);
                })
            );
    }

    getCategoriiDocumentePublic() {
        return this.http.get(this.getCategoriiDocumentePublicUrl, this.httpOptions);
    }

    updateCategorie(data: CategorieDocumenteEditPayload) {
        return this.http.put(this.updateCategorieDocumenteUrl, data, this.httpOptions);
    }

    deleteCategorie(id: number) {
        return this.http.delete(this.deleteCategorieDocumenteUrl + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }

    updateOrder(id: number, data: any) {
        return this.http.put(this.updateOrderUrl + id, data, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }
}
